module.exports = __webpack_public_path__ + "eb7cb2038a1665d3b2c77ed85f879031.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/sec-4/ck.jpg
// module id = ./app/containers/StaticPage/ComeBack/assets/sec-4/ck.jpg
// module chunks = 40